




























































































import { studentDetail } from "@/api/studyDetails";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  cameraId: string = "";
  cameraList: any[] = [];
  cameraReady: boolean = false;
  studentInfo = {
    name: "",
    mobile: "",
  };
  shootResName: string = "";
  shootResUrl: string = "";
  mounted() {
    const self = this as any;
    // 请求学生数据
    const sid = self.$route.query.id;
    if (sid) {
      studentDetail({
        student_id: sid,
      }).then((res) => {
        this.studentInfo = {
          name: res.data.name,
          mobile: res.data.mobile,
        };
      });
    }
    // 初始化摄像头
    if (window.navigator.mediaDevices) {
      // 尝试获取权限，因为必须获取到摄像头权限之后，enumerateDevices才能返回正常设备数据
      window.navigator.mediaDevices
        .getUserMedia({ video: {} })
        .then(() => {
          // 获取设备列表
          navigator.mediaDevices.enumerateDevices().then((devices) => {
            const cameras = devices.filter((item) => item.kind == "videoinput");
            if (cameras.length > 0) {
              self.cameraList = cameras;
              self.cameraId = cameras[0].deviceId;
              self.openCamera(cameras[0].deviceId);
            } else {
              this.$message({
                type: "warning",
                message: "没有找到可用媒体设备",
              });
            }
          });
        })
        .catch((err) => {
          if (err.message === "Permission denied") {
            this.$message({
              type: "warning",
              message: "为了能正常使用拍摄功能，请允许浏览器打开摄像头",
            });
          } else {
            this.$message({
              type: "warning",
              message: err.message,
            });
          }
        });
    } else {
      this.$message({
        type: "warning",
        message: "不支持访问用户媒体设备,请更换浏览器",
      });
    }
  }
  openCamera(device_id: string) {
    const self = this as any;
    window.navigator.mediaDevices
      .getUserMedia({
        video: { deviceId: { exact: device_id }, width: 720, height: 405 },
      })
      .then(function (stream) {
        self.$nextTick(() => {
          self.$refs.cameraStreamRef.srcObject = stream;
          self.$refs.cameraStreamRef.play();
          self.cameraReady = true;
        });
      })
      .catch(function (error) {
        self.$message({
          type: "warning",
          message: "获取视频流出错",
        });
      });
  }
  handleCameraChange(v: string) {
    this.openCamera(v);
  }
  cameraShoot() {
    const self = this as any;
    if (!self.cameraReady) {
      self.$message({
        type: "warning",
        message: "摄像头未初始化",
      });
      return false;
    }
    if (self.shootResName) {
      self.shootResName = "";
      self.shootResUrl = "";
    }
    const canvas = self.$refs.cameraShootImageRef;
    const context = canvas.getContext("2d");
    context.drawImage(self.$refs.cameraStreamRef, 0, 0, 720, 405);
    self.shootResName = "拍照" + new Date().getTime() + ".png";
    self.shootResUrl = canvas.toDataURL("image/png");
  }
  onSubmit() {
    localStorage.setItem(
      "studentCameraShootData",
      JSON.stringify({
        name: this.shootResName,
        url: this.shootResUrl,
      })
    );
    window.close();
  }
}
